import { Trans } from "@lingui/macro";
import styled from "styled-components";
import { body1, heading4 } from "~/guidelines/Typography";

const SectionWrapper = styled.section`
  display: flex;
  flex-direction: row;
  max-width: 1200px;
  justify-content: center;
  align-items: flex-start;
  gap: 80px;
  margin: 80px;
  padding: 0 80px;

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-direction: column;
    gap: 32px;
    margin: 32px;
    padding: 0;
  }
`;

const LeftBlock = styled.div`
  ${heading4};
  width: 50%;

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    font-size: 22px;
    width: 100%;
  }
`;

const RightBlock = styled.div`
  ${body1};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  padding-left: 50px;

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding-left: 0;
    width: 100%;
  }
`;

const Paragraph = styled.p`
  margin: 0;
`;

const ConnectedHotelsSection = () => (
  <SectionWrapper>
    <LeftBlock>
      <Trans>
        Authentic and connected hotels at the heart of our territories
      </Trans>
    </LeftBlock>

    <RightBlock>
      <Paragraph>
        <Trans>
          We transform <b>distinctive buildings</b> into <b>connected hotels</b>{" "}
          with high-end comfort and optimized operations. Our ambition: to
          become the French benchmark for autonomous hospitality by combining
          proprietary technology and heritage rehabilitation.
        </Trans>
      </Paragraph>

      <br />

      <Paragraph>
        <Trans>
          Thanks to our <b>technological DNA</b>, we optimize operational
          management and offer investors a high-performance solution, combining
          performance, sustainable impact and resilience in the face of new
          expectations in the hotel market.
        </Trans>
      </Paragraph>
    </RightBlock>
  </SectionWrapper>
);

export default ConnectedHotelsSection;
